import { Component, OnInit } from '@angular/core';
import { CgimgsService } from 'src/app/services/cgimgs.service';
import { Cgimgs } from 'src/app/interfaces/cgimgs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss']
})
export class CarouselComponent implements OnInit {

  carousel: Cgimgs [] = []

  constructor(private getcarousel:CgimgsService, private translate:TranslateService) { }
    
  title_ar:boolean = true
  title_en:boolean = false
  description_ar:boolean = true
  description_en:boolean = false

  ngOnInit(): void {
    this.getcarousel.getCarousel().subscribe(data => {
      this.carousel = data
    })

    this.translate.onLangChange.subscribe( ()=> {
      if(this.translate.currentLang == "en") {
        this.description_ar = false
        this.description_en = true
        this.title_ar = false
        this.title_en = true
      }
      else if(this.translate.currentLang == "ar") {
        this.description_ar = true
        this.description_en = false
        this.title_ar = true
        this.title_en = false
      }
    })

  }

}
